// extracted by mini-css-extract-plugin
module.exports = {"section-wrapper":"styles_section-wrapper__3sTVU"};